import type { RootState } from 'types'

const categoriesList = (state: RootState) => state.category.categories
const storeInfo = (state: RootState) => state.category.store

export const CategoriesSelectors = {
  storeInfo,
  categoriesList,
}
